/**
 * Replace newlines by `<br/>` react elements.
 * Will return an array of strings and `ReactElements(<br/>)` in places of newlines,
 * to be rendered like `{linebreaks("foo \n bar")}`.
 *
 * @param {string} string
 * @returns {Array.(string|ReactElement)}
 */

import React from 'react';

export function djb2Code(str) {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) + hash + char; /* hash * 33 + c */
  }
  return hash;
}

export function keyedLinebreaks(stringWithNewlines) {
  const prefix = djb2Code(stringWithNewlines);
  return stringWithNewlines.split('\n').map(function (item, idx) {
    return (
      <span key={`${prefix}-${idx}`}>
        {item}
        <br />
      </span>
    );
  });
}

export function linebreaks(string) {
  const reducer = function (prevVal, currentVal) {
    prevVal.push(currentVal, <br />);
    return prevVal;
  };

  return string && string.split('\n').reduce(reducer, []);
}

/**
 * Convert leading spaces to non-breaking spaces to maintain formatting.
 * Handles multi-line text.
 *
 * @param {string} string
 * @returns {string}
 */

export function nbspaces(string) {
  const nbsp = '\u00a0',
    softtab = '\u00a0\u00a0\u00a0\u00a0';

  return (
    string &&
    string
      .replace(/\t/g, softtab)
      .replace(/\n([ ]+)/g, (match) => '\n' + repeat(nbsp, match.length - 1))
  );
}

/**
 * Repeat <string> for <repeats> times.
 *
 * @param {string} string
 * @param {number} repeats
 * @returns {string}
 */

export function repeat(string, repeats) {
  let rep = '';
  for (let i = 0; i < repeats; i++) {
    rep += string;
  }
  return rep;
}

/**
 * Generate random string by sampling <len> characters from <charSet>
 * @param {number} len
 * @param {string} charSet
 */

export function randomString(len, charSet) {
  charSet =
    charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var randomString = '';
  for (var i = 0; i < len; i++) {
    var randomPoz = Math.floor(Math.random() * charSet.length);
    randomString += charSet.substring(randomPoz, randomPoz + 1);
  }
  return randomString;
}

export function capitalize(string, firstOnly = false) {
  return (
    string.charAt(0).toUpperCase() +
    (firstOnly ? string.slice(1).toLowerCase() : string.slice(1).toLowerCase())
  );
}

export function titleize(string) {
  return string.replace(/\w+/g, function (word) {
    return capitalize(word, true);
  });
}

export function chomp(string) {
  return string.replace(/^\s+/, '').replace(/\s+$/, '');
}

export function lowercase(string) {
  return string.toLowerCase();
}

export const detectAndLinkifyUrls = (text) => {
  const urlRegex =
    /((https?:\/\/|www\.)[^\s]+|[a-zA-Z0-9-]+\.(com|org|net)(\/[^\s]*)?)/g;

  const linkedText = text.replace(urlRegex, (url) => {
    const href = url.startsWith('http') ? url : `https://${url}`;
    return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });

  return linkedText;
};
